/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './table.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '../../../../../src/app/shared/table/table.component';
const styles_TableComponent:any[] = [i0.styles];
export const RenderType_TableComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_TableComponent,data:{}});
export function View_TableComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{tableEl:0}),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),3,'div',[['class','tablesaw-overflow']],[[2,'table-responsive',
          (null as any)]],(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵeld(0,[[1,0],['table',1]],(null as any),2,'table',([] as any[]),
          [[1,'data-tablesaw-mode',0],[1,'data-tablesaw-mode-switch',0],[1,'data-tablesaw-sortable',
              0],[1,'data-tablesaw-sortable-switch',0]],(null as any),(null as any),
          (null as any),(null as any))),i1.ɵdid(278528,(null as any),0,i2.NgClass,
          [i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer],{ngClass:[0,
              'ngClass']},(null as any)),i1.ɵncd((null as any),0)],(_ck,_v) => {
    var _co:i3.TableComponent = _v.component;
    const currVal_5:any = _co.classes;
    _ck(_v,3,0,currVal_5);
  },(_ck,_v) => {
    var _co:i3.TableComponent = _v.component;
    const currVal_0:any = _co.responsive;
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = (_co.tablesaw || (null as any));
    const currVal_2:any = (_co.tablesawSwitch || (null as any));
    const currVal_3:any = ((_co.tablesaw === 'sortable')? '': (null as any));
    const currVal_4:any = ((_co.tablesaw === 'sortable')? '': (null as any));
    _ck(_v,2,0,currVal_1,currVal_2,currVal_3,currVal_4);
  });
}
export function View_TableComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-table',
      ([] as any[]),(null as any),(null as any),(null as any),View_TableComponent_0,
      RenderType_TableComponent)),i1.ɵdid(4440064,(null as any),0,i3.TableComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const TableComponentNgFactory:i1.ComponentFactory<i3.TableComponent> = i1.ɵccf('admin-table',
    i3.TableComponent,View_TableComponent_Host_0,{datatable:'datatable',tablesaw:'tablesaw',
        tablesawSwitch:'tablesawSwitch',striped:'striped',bordered:'bordered',hover:'hover',
        condensed:'condensed',responsive:'responsive'},{},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL3RhYmxlL3RhYmxlLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL2tzbWFpL3dlYmRldi9hZG1pbi10ZW1wbGF0ZS9zcmMvYXBwL3NoYXJlZC90YWJsZS90YWJsZS5jb21wb25lbnQudHMiLCJuZzovLy9ob21lL2tzbWFpL3dlYmRldi9hZG1pbi10ZW1wbGF0ZS9zcmMvYXBwL3NoYXJlZC90YWJsZS90YWJsZS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL3RhYmxlL3RhYmxlLmNvbXBvbmVudC50cy5UYWJsZUNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgW2NsYXNzLnRhYmxlLXJlc3BvbnNpdmVdPVwicmVzcG9uc2l2ZVwiIGNsYXNzPVwidGFibGVzYXctb3ZlcmZsb3dcIj48dGFibGUgW25nQ2xhc3NdPVwiY2xhc3Nlc1wiICN0YWJsZSBbYXR0ci5kYXRhLXRhYmxlc2F3LW1vZGVdPVwidGFibGVzYXcgfHwgbnVsbFwiIFthdHRyLmRhdGEtdGFibGVzYXctbW9kZS1zd2l0Y2hdPVwidGFibGVzYXdTd2l0Y2ggfHwgbnVsbFwiIFthdHRyLmRhdGEtdGFibGVzYXctc29ydGFibGVdPVwidGFibGVzYXcgPT09ICdzb3J0YWJsZScgPyAnJyA6IG51bGxcIiBbYXR0ci5kYXRhLXRhYmxlc2F3LXNvcnRhYmxlLXN3aXRjaF09XCJ0YWJsZXNhdyA9PT0gJ3NvcnRhYmxlJyA/ICcnOm51bGxcIj48bmctY29udGVudD48L25nLWNvbnRlbnQ+PC90YWJsZT48L2Rpdj4iLCI8YWRtaW4tdGFibGU+PC9hZG1pbi10YWJsZT4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7O3FEQ0FBO01BQUE7VUFBQTtNQUFxRTtVQUFBO2NBQUE7VUFBQSxxQ0FBQTtVQUFBO2NBQUEsa0NBQXNSOztJQUEvUTtJQUFQLFdBQU8sU0FBUDs7O0lBQWhFO0lBQUwsV0FBSyxTQUFMO0lBQXVHO0lBQTZDO0lBQTBEO0lBQW9FO0lBQTdNLFdBQWtDLFVBQTZDLFVBQTBELFVBQW9FLFNBQTdNOzs7O29CQ0FyRTtNQUFBOytCQUFBLFVBQUE7TUFBQTtJQUFBOzs7Ozs7In0=



// WEBPACK FOOTER //
// ./$$_gendir/src/app/shared/table/table.component.ngfactory.ts